//@flow
import { urlsConstants } from './../_constants/urls.constant';
import { defaultService } from './defaultService';

export const IntegracaoSascConnectService = {
  findByFiltro,
};

function findByFiltro(options: Options, filter: any): Promise<Array<>> {
  return defaultService.findByFiltro(
    `${urlsConstants.GUIA_SASCCONNECT}list`,
    options,
    filter
  );
}
